import script from "./WebGLPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WebGLPage.vue?vue&type=script&setup=true&lang=js"

import "./WebGLPage.vue?vue&type=style&index=0&id=fc4f579e&lang=scss"

const __exports__ = script;

export default __exports__